<template>
  <div class="h-full flex flex-col overflow-hidden">
    <router-link
      class="bg-blue-800 flex items-center justify-center text-white text-sm md:text-md font-medium hover:bg-blue-700 transition-all"
      style="height: 50px" to="/admin" v-if="userInfo.role.includes('admin')">Currently in Stringer Area <span
        class="px-2 block">&bull;</span> Click
      to Return to Admin
    </router-link>

    <!-- :style="{
        height: userInfo.role.includes('admin') ? 'calc(100vh - 50px)' : ''
      }" -->
    <div class="flex-1 overflow-y-auto bg-gray-100" v-on:scroll="handleScroll">
      <header class="pb-24 bg-gradient-to-r from-light-blue-800 to-cyan-600">
        <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8 py-4 lg:py-0">
          <div class="relative flex flex-wrap items-center justify-center lg:justify-between">
            <!-- Logo -->
            <div class="absolute left-0 py-5 flex-shrink-0 lg:static text-white">
              <router-link :to="{ name: 'StringerHome' }" class="flex flex-row items-center space-x-2">
                <img class="h-8 w-auto" src="@/assets/tornado.png" alt="Workflow" />
                <span class="text-xl">
                  Live Storms Media
                </span>
              </router-link>
            </div>

            <!-- Right section on desktop -->
            <div class="hidden lg:ml-4 lg:flex lg:items-center lg:py-5 lg:pr-0.5">
              <router-link :to="{ name: 'StringerUpload' }"
                class="h-8 flex items-center justify-center text-sm px-4 rounded-full text-white font-medium bg-green-500">
                Upload
              </router-link>

              <!-- <button
                type="button"
                class="flex-shrink-0 p-1 text-cyan-200 rounded-full hover:text-white hover:bg-white hover:bg-opacity-10 focus:outline-none focus:ring-2 focus:ring-white"
              >
                <span class="sr-only">View notifications</span>
                <svg
                  class="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                  />
                </svg>
              </button> -->

              <!-- Profile dropdown -->
              <div class="ml-4 relative flex-shrink-0">
                <div>
                  <button type="button"
                    class="bg-white rounded-full flex text-sm ring-2 ring-white ring-opacity-20 focus:outline-none focus:ring-opacity-100"
                    id="user-menu" aria-expanded="false" aria-haspopup="true"
                    @click="navDropdownOpen = !navDropdownOpen">
                    <span class="sr-only">Open user menu</span>
                    <AccountIcon :initials="userInitials" :size="8" />
                  </button>
                </div>

                <transition>
                  <div class="z-20 fixed inset-0" aria-hidden="true" v-if="navDropdownOpen"
                    @click.self="navDropdownOpen = !navDropdownOpen"></div>
                  <!-- bg-black bg-opacity-25 -->
                </transition>

                <transition leave-active-class="transition ease-in duration-75"
                  leave-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
                  <div
                    class="origin-top-right z-40 absolute -right-2 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                    role="menu" aria-orientation="vertical" aria-labelledby="user-menu" v-if="navDropdownOpen"
                    @click="navDropdownOpen = !navDropdownOpen">
                    <router-link :to="{ name: 'StringerSettings' }"
                      class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Settings</router-link>
                    <a href="#" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" v-on:click="
                      () => {
                        logout();
                        $router.push('/');
                      }
                    ">Sign out</a>
                  </div>
                </transition>
              </div>
            </div>

            <div class="w-full py-5 lg:border-t lg:border-white lg:border-opacity-20">
              <!-- Left nav -->
              <div class="hidden lg:block lg:col-span-2">
                <nav class="flex space-x-4">
                  <router-link :to="{ name: 'StringerHome' }"
                    class="text-cyan-100 text-sm font-medium rounded-md bg-white bg-opacity-0 px-3 py-2 hover:bg-opacity-10"
                    active-class="text-white">
                    Home</router-link>
                  <router-link :to="{ name: 'StringerVideos' }"
                    class="text-cyan-100 text-sm font-medium rounded-md bg-white bg-opacity-0 px-3 py-2 hover:bg-opacity-10"
                    active-class="text-white">
                    Video Manager</router-link>
                  <router-link :to="{ name: 'StringerAnnouncements' }"
                    class="text-cyan-100 text-sm font-medium rounded-md bg-white bg-opacity-0 px-3 py-2 hover:bg-opacity-10"
                    active-class="text-white">
                    Announcements</router-link>
                  <router-link :to="{ name: 'StringerVideoSales' }"
                    class="text-cyan-100 text-sm font-medium rounded-md bg-white bg-opacity-0 px-3 py-2 hover:bg-opacity-10"
                    active-class="text-white">
                    Video Sales</router-link>
                  <router-link :to="{ name: 'StringerStreamSales' }"
                    class="text-cyan-100 text-sm font-medium rounded-md bg-white bg-opacity-0 px-3 py-2 hover:bg-opacity-10"
                    active-class="text-white">
                    Stream Sales</router-link>
                  <router-link :to="{ name: 'StringerSocialIncome' }"
                    class="text-cyan-100 text-sm font-medium rounded-md bg-white bg-opacity-0 px-3 py-2 hover:bg-opacity-10"
                    active-class="text-white">
                    Social Income
                  </router-link>
                  <!-- <router-link :to="{ name: 'StringerContentRequests' }"
                    class="text-cyan-100 text-sm font-medium rounded-md bg-white bg-opacity-0 px-3 py-2 hover:bg-opacity-10"
                    active-class="text-white">
                    Content Requests
                  </router-link> -->
                  <router-link :to="{ name: 'StringerSupport' }"
                    class="text-cyan-100 text-sm font-medium rounded-md bg-white bg-opacity-0 px-3 py-2 hover:bg-opacity-10"
                    active-class="text-white">
                    Support</router-link>
                  <router-link :to="{ name: 'StringerSocialMediaLatestContent' }"
                    class="text-cyan-100 text-sm font-medium rounded-md bg-white bg-opacity-0 px-3 py-2 hover:bg-opacity-10"
                    active-class="text-white" v-if="isSocialMediaTeamMember()">
                    Social Media Team</router-link>
                </nav>
              </div>
            </div>

            <!-- Menu button -->
            <div class="absolute right-0 flex-shrink-0 lg:hidden">
              <!-- Mobile menu button -->
              <button type="button"
                class="bg-transparent p-2 rounded-md inline-flex items-center justify-center text-cyan-200 hover:text-white hover:bg-white hover:bg-opacity-10 focus:outline-none focus:ring-2 focus:ring-white"
                aria-expanded="false" v-on:click="toggleMenu">
                <span class="sr-only">Open main menu</span>

                <svg class="block h-6 w-6" :class="{ block: !menuOpen, hidden: menuOpen }"
                  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                  aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                </svg>

                <svg class="h-6 w-6" :class="{ block: menuOpen, hidden: !menuOpen }" xmlns="http://www.w3.org/2000/svg"
                  fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </header>
      <main class="-mt-24 pb-8">
        <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
          <router-view></router-view>
        </div>
      </main>
      <footer>
        <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl">
          <div class="border-t border-gray-200 py-8 text-sm text-gray-500 text-center sm:text-left">
            <span class="block sm:inline">&copy;2016-{{ new Date().getFullYear() }} Live Storms Media.
            </span>
            <span class="block sm:inline">All rights reserved.</span>
            <span class="block sm:inline">
              <router-link to="/metrics" class="text-blue-600">
                Metrics</router-link>.
            </span>
          </div>
        </div>
      </footer>
    </div>

    <!-- MOBILE NAVIGATION -->
    <transition enter-active-class="duration-150 ease-out" leave-active-class="duration-150 ease-in"
      enter-class="opacity-0" enter-to-class="opacity-100" leave-class="opacity-100" leave-to-class="opacity-0">
      <!-- Mobile menu, show/hide based on mobile menu state. -->
      <div class="lg:hidden" v-if="menuOpen">
        <div class="z-20 fixed inset-0 bg-black bg-opacity-25" aria-hidden="true" @click.self="toggleMenu"></div>
      </div>
    </transition>
    <transition enter-active-class="transition ease-in-out duration-300 transform"
      leave-active-class="transition ease-in-out duration-300 transform" enter-class="-translate-x-full"
      enter-to-class="translate-x-0" leave-class="translate-x-0" leave-to-class="-translate-x-full">
      <!-- Mobile menu, show/hide based on mobile menu state. -->
      <div class="lg:hidden" v-if="menuOpen">
        <!--
        Mobile menu, show/hide based on mobile menu state.

        Entering: "duration-150 ease-out"
          From: "opacity-0 scale-95"
          To: "opacity-100 scale-100"
        Leaving: "duration-150 ease-in"
          From: "opacity-100 scale-100"
          To: "opacity-0 scale-95"
      -->
        <div class="z-30 absolute top-0 inset-x-0 max-w-3xl mx-auto w-full p-2 transition transform origin-top">
          <div class="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y divide-gray-200">
            <div class="pt-3 pb-2">
              <div class="flex items-center justify-between px-4">
                <div class="flex flex-row items-center space-x-2">
                  <img class="h-8 w-auto" src="@/assets/tornado.png" alt="Workflow" />
                  <span class="text-xl">
                    Live Storms Media
                  </span>
                </div>
                <div class="-mr-2">
                  <button type="button"
                    class="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-cyan-500"
                    @click="toggleMenu">
                    <span class="sr-only">Close menu</span>
                    <!-- Heroicon name: outline/x -->
                    <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                      stroke="currentColor" aria-hidden="true">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
              </div>
              <div class="mt-3 px-2 space-y-1">
                <router-link :to="{ name: 'StringerHome' }"
                  class="block rounded-md px-3 py-2 text-base text-gray-900 font-medium hover:bg-gray-100 hover:text-gray-800">
                  Home
                </router-link>
                <router-link :to="{ name: 'StringerVideos' }"
                  class="block rounded-md px-3 py-2 text-base text-gray-900 font-medium hover:bg-gray-100 hover:text-gray-800">
                  Video Manager
                </router-link>
                <router-link :to="{ name: 'StringerAnnouncements' }"
                  class="block rounded-md px-3 py-2 text-base text-gray-900 font-medium hover:bg-gray-100 hover:text-gray-800">
                  Announcements
                </router-link>
                <router-link :to="{ name: 'StringerVideoSales' }"
                  class="block rounded-md px-3 py-2 text-base text-gray-900 font-medium hover:bg-gray-100 hover:text-gray-800">
                  Video Sales
                </router-link>
                <router-link :to="{ name: 'StringerStreamSales' }"
                  class="block rounded-md px-3 py-2 text-base text-gray-900 font-medium hover:bg-gray-100 hover:text-gray-800">
                  Stream Sales
                </router-link>
                <router-link :to="{ name: 'StringerSocialIncome' }"
                  class="block rounded-md px-3 py-2 text-base text-gray-900 font-medium hover:bg-gray-100 hover:text-gray-800">
                  Social Income
                </router-link>
                <!-- <router-link :to="{ name: 'StringerContentRequests' }"
                  class="block rounded-md px-3 py-2 text-base text-gray-900 font-medium hover:bg-gray-100 hover:text-gray-800">
                  Content Requests
                </router-link> -->
                <router-link :to="{ name: 'StringerSupport' }"
                  class="block rounded-md px-3 py-2 text-base text-gray-900 font-medium hover:bg-gray-100 hover:text-gray-800">
                  Support
                </router-link>
                <router-link :to="{ name: 'StringerSocialMediaLatestContent' }"
                  class="block rounded-md px-3 py-2 text-base text-gray-900 font-medium hover:bg-gray-100 hover:text-gray-800">
                  Social Media Team
                </router-link>
              </div>
            </div>
            <div class="pt-4 pb-2">
              <div class="flex items-center px-5">
                <div class="flex-shrink-0">
                  <AccountIcon :initials="userInitials" />
                </div>
                <div class="ml-3 min-w-0 flex-1">
                  <div class="text-base font-medium text-gray-800 truncate">
                    {{ userInfo.name }}
                  </div>
                  <div class="text-sm font-medium text-gray-500 truncate">
                    {{ userInfo.email }}
                  </div>
                </div>
                <button
                  class="ml-auto flex-shrink-0 bg-white p-1 text-gray-400 rounded-full hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500">
                  <span class="sr-only">View notifications</span>
                  <!-- Heroicon name: outline/bell -->
                  <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                  </svg>
                </button>
              </div>
              <div class="mt-3 px-2 space-y-1">
                <router-link :to="{ name: 'StringerUpload' }"
                  class="block rounded-md px-3 py-2 text-base text-gray-900 font-medium hover:bg-gray-100 hover:text-gray-800">
                  Upload
                </router-link>
                <a href="#"
                  class="block rounded-md px-3 py-2 text-base text-gray-900 font-medium hover:bg-gray-100 hover:text-gray-800">Settings</a>
                <a href="#"
                  class="block rounded-md px-3 py-2 text-base text-gray-900 font-medium hover:bg-gray-100 hover:text-gray-800"
                  v-on:click="
  () => {
    logout();
    $router.push('/');
  }
                  ">Sign out</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import AccountIcon from "@/components/AccountIcon";

export default {
  name: "StringerLayout",
  data() {
    return {
      menuOpen: false,
      navDropdownOpen: false
    };
  },
  computed: {
    ...mapGetters(["userInfo", "userInitials"])
  },
  components: { AccountIcon },
  methods: {
    ...mapActions(["logout"]),
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    handleScroll(e) {
      this.$eventBus.$emit("scroll");
    },
    isSocialMediaTeamMember() {
      if (this.userInfo == undefined) return false;
      const filtered = this.userInfo.roles.filter(role => {
        return role.name.toLowerCase().includes("social");
      });
      return filtered.length == 1;
    }
  }
};
</script>
